import { Link } from "react-router-dom";

export const LogoMark = ({ size = 44 }) => (
  <img
    src="/favicon.png"
    width={size}
    height={size}
    alt=""
    aria-hidden="true"
    className="rounded-[8px]"
    data-testid="logo-mark"
  />
);

const Logo = ({ dark = false }) => (
  <Link to="/" data-testid="logo-link" className="flex items-center" aria-label="Good Work Web Co. — home">
    <img
      src="/logo.png"
      alt="Good Work Web Co."
      className="h-11 sm:h-12 w-auto rounded-[6px]"
      data-testid="logo-image"
    />
  </Link>
);

export default Logo;
